import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import "./CallButton.css";

const CallButton = () => {
  const phoneNumber = "+918129879890"; // Replace with your actual phone number

  return (
    <a
      href={`tel:${phoneNumber}`}
      className="call-button"
      aria-label="Call us"
      title="Call us"
    >
      <FaPhoneAlt className="call-button__icon" />
    </a>
  );
};

export default CallButton;